export const types = {
  GET_DEVICES_INIT: "DEVICES_LIST/GET_DEVICES_INIT",
  GET_DEVICES_SUCCESS: "DEVICES_LIST/GET_DEVICES_SUCCESS",
  GET_DEVICES_FAILURE: "DEVICES_LIST/GET_DEVICES_FAILURE",
  SET_STAMPS: "DEVICE_LIST/SET_STAMPS",
};

export const initialState = {
  productsFetching: true,
  fechingError: false,
  serverRender: true,
  productsCards: null,
  id: "moviles",
  filters: [],
  selectedFilters: [],
  totalNumberOfPages: 0,
  pageIndex: 0,
  pageSize: 39,
  sort: "relevance",
  filtersApplied: 0,
  showRenewR2ROffersFilter: false,
  isBtl: false,
  hasToShowR2RRenovationOffers: false,
  showCollectivesOffersFilter: false,
  stamps: null,
  stampsFetched: false,
};

export const actions = {
  initGetDevicesList: (data) => ({
    type: types.GET_DEVICES_INIT,
    data,
  }),
  successGetDevicesList: (data) => ({
    type: types.GET_DEVICES_SUCCESS,
    payload: data,
  }),
  failureGetDevicesList: () => ({
    type: types.GET_DEVICES_FAILURE,
  }),
  setStamps: (data) => ({
    type: types.SET_STAMPS,
    payload: data,
  })
};
const DevicesList = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_DEVICES_INIT: {
      return {
        ...state,
        productsFetching: true,
      };
    }
    case types.GET_DEVICES_SUCCESS: {
      return {
        ...state,
        productsCards: action.payload,
        productsFetching: false
      };
    }
    case types.GET_DEVICES_FAILURE: {
      return {
        ...state,
        productsFetching: false,
        fechingError: true,
      };
    }
    case types.SET_STAMPS: {
      return {
        ...state,
        stamps: action.payload,
        stampsFetched: true,
      }
    }
    default:
      return state;
  }
};

export default DevicesList;
